import React, {
  Component,
  Fragment
} from 'react';
import _ from 'lodash';

import { bindActionCreators } from 'redux';

import { connect } from 'react-redux';

import FilterDropdown from './FilterDropdown';

import { removeVisibilityFilter } from '../../actions/DataDefaultActions';

export class FiltersComponent extends Component {

  setActiveFilters() {
    return this.props.activeFilter.selected.map((fil, i) => (
      <div className="control" key={`filter_${i}`}>
        <div className="tags has-addons" >
          <span className="tag is-dark">{fil.type}: {fil.filter.name}</span>
          <span className="tag is-delete" style={{ cursor: 'pointer' }} onClick={() => this.props.removeVisibilityFilter(fil)}></span>
        </div>
      </div>
    ));
  }

  render() {
    return (
      <Fragment>
        <section className="field">
          <section>
            { this.props.genres && <FilterDropdown name="Genre" items={this.props.genres} type="genre" /> }
            { this.props.moods && <FilterDropdown name="Mood" items={this.props.moods} type="mood" /> }
            { this.props.tempos && <FilterDropdown name="Tempo" items={this.props.tempos} type="tempo" /> }
            { this.props.vocals && <FilterDropdown name="Vocals" items={this.props.vocals} type="vocal" /> }
            { this.props.instruments && <FilterDropdown name="Instrument" items={this.props.instruments} type="instrument" /> }
          </section>

        </section>
        <section className="field">
          {(this.props.activeFilter.selected.length > 0) && <p className="is-inline-block has-text-white">Filtering by:</p>}
        </section>
        <div className="field is-grouped is-grouped-multiline">
          {this.setActiveFilters()}
        </div>
      </Fragment>
    );
  }
}

function mapStateToProps({ results }) {
  let genres = _.uniqBy(_.map(results.items, (song, i) => song.product_genre || []).flatten(), 'id');
  let moods = _.uniqBy(_.map(results.items, (song, i) => song.product_mood  || []).flatten(), 'id');
  let tempos = _.uniqBy(_.map(results.items, (song, i) => song.product_tempo  || []).flatten(), 'id');
  let instruments = _.uniqBy(_.map(results.items, (song, i) => song.product_instrument  || []).flatten(), 'id');

  return {
    genres: _.sortBy(_.filter(genres, 'id'), 'post_title'),
    moods: _.sortBy(_.filter(moods, 'id'), 'post_title'),
    tempos: _.sortBy(_.filter(tempos, 'id'), 'post_title'),
    instruments: _.sortBy(_.filter(instruments, 'id'), 'post_title'),
  };
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators({ removeVisibilityFilter }, dispatch);
}

export const Filters = connect(mapStateToProps, mapDispatchToProps)(FiltersComponent);


// WEBPACK FOOTER //
// ./src/components/Filters/Filters.js